import BaseResource from '@/lib/data/resource/BaseResource'

export default class MavenAdvisoryInputResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.email = payload.email ?? ''
    this.contactNumber = payload.contactNumber ?? ''
    this.subject = payload.subject ?? ''
    this.message = payload.message ?? ''
  }

  /* PROPERTIES */

  /* METHODS */
}
